const PHRASES = [
  "SYNTHETIC INTIMACY",
  "BIOMECHANICAL PERFECTION",
  "MALE ANATOMICAL PRECISION",
  "DISCREET WORLDWIDE SHIPPING",
  "EMPATHIC NEURAL CORES",
  "ABSOLUTE PRIVACY",
];

export default function Marquee() {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/8 py-6 bg-panel/60"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((p, i) => (
              <span
                key={`${half}-${i}`}
                className={`font-display font-black uppercase text-2xl sm:text-3xl tracking-tight px-8 flex items-center gap-8 ${
                  i % 2 === 0 ? "text-outline" : "text-white/85"
                }`}
              >
                {p}
                <span className="text-magma text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
